/* eslint-disable indent */
/* eslint-disable quotes */
import React, { useState, useEffect, Fragment } from "react";
import Papa from "papaparse";

import { useSelector, useDispatch } from "react-redux";
import { Image } from "react-bootstrap";

import { attendanceActions } from "../../../redux/actions";
import Button from "../../../component/button/Button";
import Card from "../../../component/card/Card";
import ErrorRender from "../../../component/request/ErrorRender";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import ResponseRender from "../../../component/request/ResponseRender";
import SelectInput from "../../../component/input/SelectInput";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Strong from "../../../component/smallComponents/Strong";
import TextInput from "../../../component/input/TextInput";

import {
  getBrowserDetails,
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction,
  toastHelper
} from "../../../constant/helper/helper";
import missing_attendance_sample from "../../../images/regularize-att.png";
import missing_attendance_sample_csv from "../../../images/regularize-att.csv";
import Starter from "../../../component/Starter";
import MissingTable from "./MissingTable";

const MissingAttendance = () => {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [date, setDate] = useState("");
  const [date2, setDate2] = useState("");
  const [isOd, setIsOd] = useState(false);
  const [errors, setErrors] = useState("");
  const [CsvData, setCsvData] = useState([]);
  const [response, setResponse] = useState("");
  const [csvFile, setCsvFile] = useState(null);
  const [shiftType, setShiftType] = useState("");
  const [sameDayOut, setSameDayOut] = useState("");
  const [twentyFour, setTwentyFour] = useState(false);
  const [allLocations, setAllLocations] = useState([]);
  const [selectLocation, setSelectLocation] = useState("");

  const { currentUser } = useSelector((state) => state.auth);

  const { locations } = useSelector((state) => state.location);

  const {
    attendanceError,
    attendanceLoading,
    attendanceResponse,
    missingAttendanceUserError
  } = useSelector((state) => state.attendance);

  useEffect(() => {
    setAllLocations(locations);
  }, [locations]);

  useEffect(() => {
    setErrors(attendanceError);
  }, [attendanceError]);

  useEffect(() => {
    setResponse(attendanceResponse);
  }, [attendanceResponse]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const browserDetail = await getBrowserDetails();
    const os = browserDetail.os.name;
    const browser = browserDetail.browser.name;

    const userCsvToJsonData = {
      isOd,
      date,
      date2,
      CsvData: CsvData,
      shiftType,
      sameDayOut,
      twentyFour,
      userId: currentUser.id,
      ipAddress: localStorage?.publicIpAdd,
      locationId: selectLocation,
      workerId: localStorage.workerId,
      deviceDetails: os + "-" + browser,
      latitude: localStorage.latitude,
      longitude: localStorage.longitude
    };
    console.log(csvFile);
    dispatch(attendanceActions.setAttendanceLoading(true));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    dispatch(
      attendanceActions.addMissingAttendance(
        userCsvToJsonData,
        loginType
      )
    );
    setCsvFile(null);
  };

  console.log(CsvData);

  useEffect(() => {
    dispatch(attendanceActions.setAttendanceLoading(false));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    return () => {
      setCsvFile(null);
      dispatch(attendanceActions.setAttendanceLoading(false));
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());
    };
  }, []);

  // handle file upload
  const convertingCsvIntoJson = (csvFile) => {
    const csvRequiredFiled = ["EMPLOYEE ID", "PRESENT"];

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: "greedy", // drop blank lines safely
      transformHeader: (h) => (h || "").trim(), // trim header keys
      transform: (v) => (typeof v === "string" ? v.trim() : v), // trim every cell
      complete: ({ data, errors }) => {
        try {
          // Optionally log parse errors from Papa
          if (errors && errors.length) {
            console.warn("Papa parse warnings/errors:", errors);
          }

          // Filter out rows that are entirely empty (all values blank after trim)
          const cleanedRows = data.filter((row) =>
            Object.values(row).some(
              (val) => String(val ?? "").trim() !== ""
            )
          );

          const jsonData = cleanedRows.map((row, index) => {
            // Validate required fields after trimming
            csvRequiredFiled.forEach((requiredField) => {
              const val = row[requiredField];
              if (val === undefined || String(val).trim() === "") {
                throw new Error(
                  `Missing or empty value for required field "${requiredField}" in row ${
                    index + 1
                  }`
                );
              }
            });

            return row;
          });

          console.log(jsonData);
          setCsvData(jsonData);
        } catch (error) {
          return toastHelper("error", error.message);
        }
      }
    });
  };

  const renderExcel = (
    <div className="row mt-3">
      <MissingTable data={CsvData} />
    </div>
  );

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-2 mt-3 col-xl-2 col-lg-2">
          <SelectInput
            required={false}
            textWhite={false}
            isLabeled={false}
            name="twentyFour"
            value={twentyFour}
            label="Select 24 hours or not"
            onChange={(e) => setTwentyFour(e.target.value)}
          >
            <option value=""> Select 24 hours or not</option>
            <option value="false">NO</option>
            <option value="true">YES</option>
          </SelectInput>
        </div>
        <div className="col-md-2 mt-3 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="shiftType"
            textWhite={false}
            isLabeled={false}
            value={shiftType}
            label="Select Shift Type"
            onChange={(e) => setShiftType(e.target.value)}
          >
            <option value=""> Select Shift</option>
            <option value="FIRST / GENERAL SHIFT">
              FIRST / GENERAL SHIFT
            </option>
            <option value="NIGHT SHIFT">NIGHT SHIFT</option>
          </SelectInput>
        </div>
        {shiftType === "NIGHT SHIFT" && (
          <div className="col-md-2 mt-3 col-xl-2 col-lg-2">
            <SelectInput
              required={true}
              name="sameDayOut"
              textWhite={false}
              isLabeled={false}
              value={sameDayOut}
              label="Select Same Day or not"
              onChange={(e) => setSameDayOut(e.target.value)}
            >
              <option value=""> Select Same Day or not</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </SelectInput>
          </div>
        )}
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="date"
            name="date"
            label="Date"
            value={date}
            htmlFor="date"
            required={true}
            textWhite={false}
            placeholder="Enter date"
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
        {twentyFour === "true" && (
          <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
            <TextInput
              type="date"
              name="date2"
              value={date2}
              htmlFor="date2"
              required={true}
              textWhite={false}
              label="Second Date"
              placeholder="Enter Second Date"
              onChange={(e) => setDate2(e.target.value)}
            />
          </div>
        )}
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            name="location"
            textWhite={false}
            isLabeled={false}
            value={selectLocation}
            label="Select Location"
            onChange={(e) => setSelectLocation(e.target.value)}
          >
            <option value=""> Select Location</option>
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput>
        </div>
        <div className="col-md-2 mt-3 col-xl-2 col-lg-2">
          <SelectInput
            name="isOd"
            value={isOd}
            required={true}
            textWhite={false}
            isLabeled={false}
            label="Select Od or not"
            onChange={(e) => setIsOd(e.target.value)}
          >
            <option value=""> Select Od or not</option>
            <option value={false}>NO</option>
            <option value={true}>YES</option>
          </SelectInput>
        </div>

        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="file"
            file={true}
            accept=".csv"
            required={true}
            textWhite={false}
            htmlFor="csvFile"
            onChange={(e) => {
              const csvFile = e.target.files[0];
              convertingCsvIntoJson(csvFile);
              setCsvFile(csvFile);
            }}
            label="Add CSV File to Add Missing Attendance of Multiple User"
          />
        </div>
        <div className="form-group text-center col-sm-2 mt-2 col-xl-2 col-lg-2">
          {attendanceLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  return (
    <Starter
      topBarTitle="Missing Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">
            Missing Attendance
          </li>
        </Fragment>
      }
    >
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <div className="row">
              <div className="col-lg-12">
                <Strong
                  title="All inputs are compulsory*"
                  className="text-danger float-right"
                />
                <HeaderTag
                  type="h4"
                  title="Add Missing Attendance CSV List"
                  isClassName={false}
                />
                <P title="Fill the form below to Missing Attendance List" />
                <HeaderTag
                  type="h4"
                  title="[ SYSTEM ONLY ACCEPT CSV FILE ]"
                  className="text-danger"
                  isClassName={true}
                />
              </div>
            </div>
            {topInput}
            {errors && <ErrorRender errors={errors} />}
            {missingAttendanceUserError &&
              missingAttendanceUserError.map((data, i) => (
                <ErrorRender errors={data} key={i} />
              ))}
            {response && <ResponseRender response={response} />}
          </Card>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-12">
          <button>
            <a href={missing_attendance_sample_csv} download>
              Download Sample Excel File To Add Missing Attendance
            </a>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3">
          <Image src={missing_attendance_sample} fluid />
        </div>
        <div className="col-lg-9">
          <Card>{renderExcel}</Card>
        </div>
      </div>
    </Starter>
  );
};

export default MissingAttendance;
